<div class="flex h-full flex-col">
  <!-- Messages Container -->
  <div class="flex flex-1 flex-col-reverse overflow-y-auto px-3 pt-4 pb-16">
    @for (chat of reversedChats(); track $index) {
      <div
        class="mb-3 flex"
        [ngClass]="{
          'justify-start': chat.position === 'start',
          'justify-end': chat.position === 'end',
        }"
      >
        <div class="flex max-w-[75%] items-end gap-2">
          @if (chat.position === "start") {
            <div class="flex-shrink-0"></div>
          }

          <div
            class="flex flex-col rounded-2xl px-4 py-2.5 shadow-sm"
            [ngClass]="{
              'bg-slate-100 dark:bg-slate-800 rounded-br-sm': chat.position === 'start',
              'bg-stone-100 dark:bg-stone-900 rounded-bl-sm': chat.position === 'end',
            }"
          >
            @if (chat.attachment) {
              <div class="mb-2 flex justify-end">
                @if (chat.id !== "pending") {
                  <mtjr-img
                    [src]="chat.attachment"
                    imgClass="w-32 aspect-square rounded-xl object-cover border border-solid border-medium/20"
                    alt="attachment"
                  />
                } @else {
                  <div
                    class="w-32 aspect-square bg-light/50 rounded-xl border border-solid border-medium/20 animate-pulse"
                  ></div>
                }
              </div>
            }

            <ion-text class="text-sm leading-relaxed">{{ chat.text }}</ion-text>

            <ion-text class="mt-1.5 text-xs opacity-60" color="medium">
              {{ chat.createdAt | date: "dd-MM-yyyy HH:mm" }}
            </ion-text>
          </div>

          @if (chat.id === "pending") {
            <ion-spinner color="primary" name="circles" class="mb-1 scale-75" />
          }

          @if (chat.position === "end") {
            <div class="flex-shrink-0"></div>
          }
        </div>
      </div>
    } @empty {
      <div class="flex flex-1 items-center justify-center">
        <div class="flex flex-col items-center gap-3 opacity-50">
          <ion-icon name="chatbubbles-outline" class="text-6xl"></ion-icon>
          <ion-text color="medium" class="text-center">{{ "CHAT.NO_MESSAGES" | translate }}</ion-text>
        </div>
      </div>
    }
  </div>

  <!-- Image Preview Modal -->
  <ion-modal [isOpen]="imageView() !== undefined" (willDismiss)="imageView.set(undefined)" cssClass="rounded-dialog">
    <ng-template>
      <ion-header [translucent]="true">
        <ion-toolbar>
          <ion-title>{{ attachment()?.name }}</ion-title>
          <ion-buttons slot="start">
            <ion-button (click)="imageView.set(undefined)">
              <ion-icon name="close" slot="icon-only"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <img [src]="imageView()" [alt]="imageView()" class="h-full w-full object-contain" />
      </ion-content>
    </ng-template>
  </ion-modal>

  <!-- Input Area - Fixed at Bottom -->
  <div class="sticky bottom-0 flex-shrink-0 border-t border-light/50 bg-surface rounded-t-2xl px-4 py-3">
    @if (attachment(); as file) {
      <div class="mb-2 flex items-center gap-2 rounded-xl bg-light/30 px-3 py-2">
        <ion-icon name="image" class="text-lg text-primary"></ion-icon>
        <ion-text color="primary" class="flex-1 truncate text-sm" (click)="openAttachment(file)">
          {{ file.name }}
        </ion-text>
        <ion-button fill="clear" size="small" color="danger" (click)="attachment.set(undefined)">
          <ion-icon name="close-circle" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
    }

    <div class="flex items-center items-end gap-2 rounded-2xl bg-stone-100 dark:bg-stone-900 px-2 py-1.5 shadow-sm">
      <ion-button fill="clear" size="small" class="flex-shrink-0" (click)="fileInput.click()">
        <ion-icon slot="icon-only" name="image-outline" class="text-xl"></ion-icon>
      </ion-button>

      <input type="file" class="hidden" (change)="onFilesPicked($event)" accept="image/*" #fileInput />

      <ion-textarea
        class="flex-1 border-none"
        style="--padding-top: 8px; --padding-bottom: 8px; --padding-start: 8px; --padding-end: 8px"
        [placeholder]="'CHAT.TYPE_MESSAGE' | translate"
        rows="1"
        autoGrow="true"
        [maxlength]="500"
        (input)="onTextChanged($event)"
        (keydown)="onKeyDown($event)"
        [value]="chatText()"
        [disabled]="isSending()"
      ></ion-textarea>

      <ion-button
        fill="clear"
        shape="round"
        class="flex-shrink-0"
        (click)="send()"
        [disabled]="!chatText().trim().length || isSending()"
      >
        @if (isSending()) {
          <ion-spinner slot="icon-only" name="circles" />
        } @else {
          <ion-icon slot="icon-only" name="send"></ion-icon>
        }
      </ion-button>
    </div>
  </div>
</div>
